import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current: {
    name: "Current FY",
    value: "",
    startDate: "",
    endDate: "",
  },
  next: {
    name: "Next FY",
    value: "",
    startDate: "",
    endDate: "",
  },
  son: {
    name: "SoN FY",
    value: "",
    startDate: "",
    endDate: "",
  },
};

export function getFiscalYearDetails(date, FY, opt_monthStart = 9) {
  const month = date.getMonth() + 1; // JavaScript months are 0-based
  const year = date.getFullYear();

  // Calculate the fiscal year offset
  const yearOffset = Math.floor((month - (opt_monthStart % 12 || 12)) / 12) + 1;
  const fiscalYear = FY === "Current" ? year + yearOffset : year + yearOffset + 1;

  // Start date of the fiscal year
  const FYStartDate = new Date(fiscalYear - 1, opt_monthStart - 1, 1).toISOString().split("T")[0];
  // End date of the fiscal year
  const FYEndDate = new Date(fiscalYear, opt_monthStart - 1, 0).toISOString().split("T")[0];

  return {
    fiscalYear,
    FYStartDate,
    FYEndDate,
  };
}

export const fiscalYearSlice = createSlice({
  name: "FY",
  initialState,
  reducers: {
    setCurrentFY: (state, action) => {
      state.current.value = action.payload.fiscalYear;
      state.current.startDate = action.payload.FYStartDate;
      state.current.endDate = action.payload.FYEndDate;
    },
    setNextFY: (state, action) => {
      state.next.value = action.payload.fiscalYear;
      state.next.startDate = action.payload.FYStartDate;
      state.next.endDate = action.payload.FYEndDate;
    },
    setSonFY: (state, action) => {
      state.son.value = action.payload.fiscalYear;
      state.son.startDate = action.payload.FYStartDate;
      state.son.endDate = action.payload.FYEndDate;
    },
  },
});

export const { setCurrentFY, setNextFY, setSonFY } = fiscalYearSlice.actions;
export default fiscalYearSlice.reducer;

export const setFiscalYear = () => {
  return (dispatch) => {
    dispatch(setCurrentFY(getFiscalYearDetails(new Date(), "Current")));
    dispatch(setNextFY(getFiscalYearDetails(new Date(), "Next")));
    dispatch(setSonFY(getFiscalYearDetails(new Date(), "SoN", 11)));
  };
};
